import { render } from "./CreateGroupsModal.vue?vue&type=template&id=74fe8136&scoped=true"
import script from "./CreateGroupsModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupsModal.vue?vue&type=script&lang=js"

import "./CreateGroupsModal.vue?vue&type=style&index=0&id=74fe8136&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fe8136"]])

export default __exports__